import React, { useState } from 'react';
import {
  TextField,
  Button,
  Typography,
  Container,
  Box,
  Alert,
  Link as MuiLink,
  CircularProgress
} from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const LoginPage = () => {
  const [identificador, setIdentificador] = useState('');
  const [senha, setSenha] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [tentativasRestantes, setTentativasRestantes] = useState(null);
  const [emailNaoVerificado, setEmailNaoVerificado] = useState(false);

  const navigate = useNavigate();
  const { login, resendVerification } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setEmailNaoVerificado(false);
    setTentativasRestantes(null);

    try {
      const result = await login(identificador, senha);
      console.log('Login bem-sucedido:', result);

      // Verifica se há um returnTo na URL
      const params = new URLSearchParams(window.location.search);
      const returnTo = params.get('returnTo');

      // Se houver returnTo E o usuário for estudante, redireciona para returnTo
      if (returnTo && result.user.tipo === 'estudante') {
        navigate(returnTo);
      } else {
        // Mantém o comportamento padrão para outros casos
        navigate('/dashboard');
      }

    } catch (error) {
      console.error('Erro no login:', error);
      
      if (error.message.includes('verifique seu email')) {
        // Verificar metodoCadastro através do erro.response.data
        if (error.message && error.message.includes('verifique seu email')) {
          setEmailNaoVerificado(true);
        }
      } else if (error.response?.data?.tentativasRestantes) {
        setTentativasRestantes(error.response.data.tentativasRestantes);
      }
    
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleReenviarVerificacao = async () => {
    try {
      setLoading(true);
      await resendVerification(identificador);
      setError('');
      setEmailNaoVerificado(false);
      alert('Email de verificação reenviado com sucesso!');
    } catch (error) {
      setError('Erro ao reenviar email de verificação: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h5">
          Login
        </Typography>

        {error && (
          <Alert 
            severity="error" 
            sx={{ width: '100%', mt: 2 }}
            action={
              emailNaoVerificado && (
                <Button 
                  color="inherit" 
                  size="small"
                  onClick={handleReenviarVerificacao}
                  disabled={loading}
                >
                  Reenviar Verificação
                </Button>
              )
            }
          >
            {error}
            {tentativasRestantes && (
              <Typography variant="body2">
                Tentativas restantes: {tentativasRestantes}
              </Typography>
            )}
          </Alert>
        )}

        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{ mt: 1, width: '100%' }}
        >
          <TextField
            margin="normal"
            required
            fullWidth
            id="identificador"
            label="Email ou Username"
            name="identificador"
            autoComplete="username"
            autoFocus
            value={identificador}
            onChange={(e) => setIdentificador(e.target.value)}
            disabled={loading}
          />

          <TextField
            margin="normal"
            required
            fullWidth
            name="senha"
            label="Senha"
            type="password"
            id="senha"
            autoComplete="current-password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            disabled={loading}
          />
          
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Entrar'}
          </Button>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <MuiLink 
              component={Link} 
              to="/esqueci-senha" 
              variant="body2"
              sx={{ cursor: 'pointer' }}
            >
              Esqueceu sua senha?
            </MuiLink>
            <MuiLink 
              component={Link} 
              to="/registro" 
              variant="body2"
              sx={{ cursor: 'pointer' }}
            >
              Não tem uma conta? Registe-se
            </MuiLink>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default LoginPage;